var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',{staticClass:"mt-5"},[_c('mdb-card',[_c('mdb-card-body',[_c('h1',{staticClass:"mb-5"},[_vm._v("TFFI Digital Accessibility Statement")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }